<template>
  <section class="integration-section">
    <div class="slanted-top"></div>
    <div class="container">
      <div class="row align-items-center">
        <div class="col-lg-6 order-lg-1">
          <div class="integration-image-container">
            <img :src="require('@/assets/img/Container (3).png')" alt="Application mobile" class="phone-integration">
          </div>
        </div>
        <div class="col-lg-6 order-lg-2">
          <div class="integration-content">
            <h2 class="integration-title">
              Renforcer l'intégration financière en 
              <span class="underlined-word">
                Afrique
                <svg class="curved-underline" viewBox="0 0 120 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M2 8 Q60 2, 118 8" stroke="#F5A847" stroke-width="3" stroke-linecap="round"/>
                </svg>
              </span>
            </h2>
            <p class="integration-description">
              Notre vision est de construire une Afrique où chaque individu a 
              accès à des services financiers modernes et inclusifs.
            </p>
            <div class="features-grid">
              <div class="feature-item">
                <div class="feature-icon">
                  <i class="bi bi-hand-thumbs-up"></i>
                </div>
                <p class="feature-text">Faciliter l'accès</p>
              </div>
              <div class="feature-item">
                <div class="feature-icon">
                  <i class="bi bi-people"></i>
                </div>
                <p class="feature-text">Promouvoir l'adoption</p>
              </div>
              <div class="feature-item">
                <div class="feature-icon">
                  <i class="bi bi-building"></i>
                </div>
                <p class="feature-text">Accélérer l'inclusion financière</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="slanted-bottom"></div>
  </section>
</template>

<script>
export default {
  name: "IntegrationSection"
};
</script>

<style scoped>
.integration-section {
  background: #3D2F1F;
  padding: 150px 0 120px;
  position: relative;
  color: white;
  overflow: hidden;
  min-height: 700px;
}

.slanted-top {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100px;
  background: white;
  transform: skewY(-2deg);
  transform-origin: top left;
  z-index: 1;
}

.slanted-bottom {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100px;
  background: white;
  transform: skewY(-2deg);
  transform-origin: bottom right;
  z-index: 1;
}

.container {
  position: relative;
  z-index: 2;
}

.integration-image-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2rem;
}

.phone-integration {
  width: 100%;
  max-width: 320px;
  height: auto;
  object-fit: contain;
  filter: drop-shadow(0 20px 40px rgba(0,0,0,0.3));
}

.integration-content {
  padding: 2rem;
  padding-left: 3rem;
}

.integration-title {
  font-size: 2.75rem;
  font-weight: 800;
  color: white;
  line-height: 1.15;
  margin-bottom: 1.5rem;
  letter-spacing: -0.03em;
}

.underlined-word {
  position: relative;
  display: inline-block;
  white-space: nowrap;
}

.curved-underline {
  position: absolute;
  bottom: -5px;
  left: 50%;
  transform: translateX(-50%);
  width: 110%;
  height: 12px;
  pointer-events: none;
}

.integration-description {
  font-size: 1.05rem;
  color: rgba(255, 255, 255, 0.85);
  line-height: 1.65;
  margin-bottom: 3rem;
  font-weight: 400;
}

.features-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
}

.feature-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.feature-icon {
  width: 70px;
  height: 70px;
  background: white;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1rem;
  box-shadow: 0 4px 15px rgba(0,0,0,0.1);
}

.feature-icon i {
  font-size: 30px;
  color: #F5A847;
}

.feature-text {
  font-size: 0.95rem;
  color: white;
  font-weight: 500;
  margin: 0;
  line-height: 1.4;
}

@media (max-width: 992px) {
  .integration-section {
    padding: 100px 0 60px;
  }

  .integration-title {
    font-size: 2rem;
  }

  .integration-content {
    padding: 2rem;
    padding-left: 2rem;
  }

  .features-grid {
    gap: 1.5rem;
  }
  
  .slanted-top,
  .slanted-bottom {
    height: 60px;
  }
}

@media (max-width: 768px) {
  .integration-section {
    padding: 80px 0 60px;
  }

  .integration-content {
    padding: 1rem;
    text-align: center;
  }

  .integration-title {
    font-size: 1.75rem;
  }

  .integration-description {
    font-size: 0.95rem;
  }

  .features-grid {
    grid-template-columns: 1fr;
    gap: 2rem;
    max-width: 300px;
    margin: 0 auto;
  }

  .phone-integration {
    max-width: 280px;
    margin-bottom: 2rem;
  }
  
  .slanted-top,
  .slanted-bottom {
    height: 40px;
  }
}
</style>
